<li class="nav-item me-2">
  <button *ngIf="_data.configuration['phoneKindTitle'].length == 0" (click)="getTicket()" class="btn btn-dark" href="#"><i class="fa fa-phone" aria-hidden="true"></i> {{ "phoneAttention" | language }}</button>
  <button *ngIf="_data.configuration['phoneKindTitle'].length > 0" (click)="getTicket()" class="btn btn-dark" href="#"><i class="fa fa-phone" aria-hidden="true"></i> {{ _data.configuration['phoneKindTitle'] }}</button>
</li>
